import { render, staticRenderFns } from "./BasicOutputCanvas.vue?vue&type=template&id=c852f3d8&scoped=true"
import script from "./BasicOutputCanvas.vue?vue&type=script&lang=js"
export * from "./BasicOutputCanvas.vue?vue&type=script&lang=js"
import style0 from "./BasicOutputCanvas.vue?vue&type=style&index=0&id=c852f3d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c852f3d8",
  null
  
)

export default component.exports